import { Flex, Switch } from 'antd'

interface Props<T> {
  entity: T
  setEntity: (entity: T) => void
}

export const UiAccessSwitch = <T extends object>({ entity, setEntity }: Props<T>) => (
  <Flex align="center">
    <span style={{ marginRight: 8 }}>UI Access</span>
    <Switch size="small" checked={entity['uiAccess']} onChange={(value) => setEntity({ ...entity, uiAccess: value })} />
  </Flex>
)